import { CurriedFunction1, CurriedFunction2, CurriedFunction3, CurriedFunction4 } from 'lodash';
import * as _4 from 'lodash';

type condition<C> = (c: C) => boolean;
interface IStateSwitch<C> {
  condition: (condition<C> | boolean);
  onEnter?: (c: C) => void;
};

type IStateDescriptor<C> = IStateSwitch<C> | boolean;

type IStateCondition<C, T extends string> = {
  [K in T]: IStateDescriptor<C>;
};

/**
 * ConditionalState
 *
 * @description represents logic around transitioning from one state (algorithm selection) to another
 */
export class ConditionalState<C, T extends string> {

  constructor(private __rules: Record<T, IStateCondition<C, T>>) {

  }

  transition: CurriedFunction3<C, T, T, T> = _4.curry((executionContext: C, currentStateKey: T, newStateKey: T): T => {

    const currentState: IStateCondition<C, T> = this.__rules[currentStateKey];
    const newState: IStateDescriptor<C> = currentState[newStateKey];

    if (typeof newState === 'boolean') {
      return (newState)
        ? newStateKey
        : currentStateKey;
    }

    const willTransition: boolean = (typeof newState.condition === 'boolean')
      ? newState.condition
      : newState.condition(executionContext);

    if (willTransition && typeof newState.onEnter === 'function') {
      newState.onEnter(executionContext);
    }

    return (willTransition)
      ? newStateKey
      : currentStateKey;
  });

}

export class ConditionalStateSafe<C, T extends string> extends ConditionalState<C, T> {

}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-strategy/dist/lib/conditional_state.ts